import {  ObjectTypeName } from 'phoenix/domain';

export type AclPrincipal = ServerAcl | LegacyLinkAcl | LinkAcl | ReceivedShareInfo | PermissionType;

export interface ServerAcl {
	elementId: number;
	userId: number;
	userName: string;
	isGroup: boolean;
}

export interface LegacyLinkAcl {
	AuthToken: string;
	ReferenceString: string;
	FolderName: string;
}

export interface LinkAcl {
	ObjectType: ObjectTypeName;
	ReferenceString: string;
	Permissions: number;
}

export type ShareEntity = UserEntity | UserGroupEntity;

export interface UserEntity {
	UserId: number;
	UserName: string;
}

export interface UserGroupEntity {
	UserGroupId: number;
	UserGroupName: string;
}

export interface ShareInfo {
	Embedded: {
		Permissions: Permission[];
	};
	RoleName: string;
	UserName: string;
	UserId: number;
	UserGroupName: string;
	UserGroupId: number;
}

export interface ReceivedShareInfo extends ShareInfo{
	DateCreated: string | Date;
	CreatorId: number;
	DenyPrivileges: number;
	Privileges: number;
	SourceLibraryId?: number;
	SourceLibraryName?: string;
	SourceFolderId?: number;
	SourceFolderName?: string;
	IsExpired?: boolean;
}

export interface FolderShare extends ReceivedShareInfo {
	FolderId:number;
	FolderACLId:number;
}

export interface DocumentShare extends ReceivedShareInfo {
	DocumentId:number;
	DocumentACLId:number;
}

export interface LibraryShare extends ReceivedShareInfo {
	LibraryId?:number;
	LibraryACLId:number;
}

export interface Permission {
	PermissionValue: number;
	PermissionName?: string;
	ForObjectType?: string;
	Allow: boolean;
	Deny: boolean;
}

export interface DefaultRight {
	id: RightsType;
	defaultPerms: PermissionsTuple;
	opts: boolean;
	name: string;
}

interface PermissionsTuple {
	document: number;
	folder: number;	
	library: number;
}

export interface RightsOption {
	id: RightsType,
	name: string,
	mask: number|number[],
	apply?: string,
	constr?: string,
	embedded?: {
		options: AdvancedOption[]
	}
}

export interface AdvancedOption {
	id: number;
	name: string;
	value: boolean;
	permissions: PermissionType;
	constraints: string;
	apply?: string;
}

export enum RightsType {
	UNDEFINED = 0,
	FULLCONTROL,
	EDIT,
	VIEW,
	UPLOADONLY,
	NOACCESS
}

// assign values explicitly to ensure a bit flag
export enum LinkSettings {
	AuthRequired = 1, 
	PasswordRequired = 2, 
	SingleUse = 4,
	PinRequired = 8
}

// assign values explicitly to ensure a bit flag
export enum PermissionType {
	FULLCONTROL = -1, 
	NONE = 0,
	READ = 0x0001, 
	MODIFY = 0x0002, 
	DELETE = 0x0004, 
	ADDDOC = 0x0008,
	READDOC = 0x0010, 
	MODDOC = 0x0020, 
	DELDOC = 0x0040, 
	ADDFOLD = 0x0080,
	READFOLD = 0x0100, 
	MODFOLD = 0x0200, 
	DELFOLD = 0x0400, 
	LISTFOLD = 0x0800,
	SHARE = 0x1000, 
	SHLINK = 0x2000, 
	SHLINKR = 0x4000, 
	DOWNLOAD = 0x8000,
	SHDOC = 0x10000, 
	SHLKDOC = 0x20000, 
	SHLKRDOC = 0x40000, 
	DNLDDOC = 0x80000,
	SHFOLD = 0x200000, 
	SHLKFOLD = 0x400000, 
	SHLKRFOLD = 0x800000, 
	DNLDFOLD = 0x100000,
	UPLOADONLY = 0x0009
};

let TypeGuards = {
 	isDocumentShare: (srvData:ReceivedShareInfo): srvData is DocumentShare => angular.isDefined((srvData as DocumentShare).DocumentACLId),
	isFolderShare: (srvData:ReceivedShareInfo): srvData is FolderShare => angular.isDefined((srvData as FolderShare).FolderACLId),
	isLibraryShare: (srvData:ReceivedShareInfo): srvData is LibraryShare => angular.isDefined((srvData as LibraryShare).LibraryACLId)
};

export enum ObjectType {
	UNDEFINED = -1,
	DOCUMENT, 
	FOLDER,
	LIBRARY
}

export { TypeGuards };


// WEBPACK FOOTER //
// ./src/phoenix/domain/phoenix-acl.ts